import { Link } from "react-router-dom";

export const FinalCta = ({
    title = "Combien payez-vous de trop à votre banque ?",
    text = "Estimation en 30 secondes, anonyme et sans engagement.",
    band = false,
}) => (
    <section className={`${band ? "bg-navy-band" : "bg-navy"} text-white`} data-testid="final-cta">
        <div className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-12 md:py-[72px] flex flex-wrap justify-between items-center gap-6">
            <div className="flex flex-col gap-2.5 flex-1 basis-[420px] min-w-0">
                <h2 className="m-0 font-bold text-[26px] md:text-[38px] leading-[1.15] tracking-[-0.02em] text-white">{title}</h2>
                <p className="m-0 text-base text-on-navy">{text}</p>
            </div>
            <Link
                to="/simulateur"
                data-testid="cta-simulator-bottom"
                className="w-full sm:w-auto justify-center inline-flex items-center h-[54px] px-[26px] rounded-md bg-gold text-navy text-base font-semibold transition-[transform,box-shadow] hover:-translate-y-[1px] hover:shadow-lg"
            >
                Simuler mes économies
            </Link>
        </div>
    </section>
);
